import React from "react";
import FadeInAnimation from "../components/FadeInAnimation";
import PageWrapper from "../components/PageWrapper";
import "./AboutUs.css";
import { Helmet } from "react-helmet-async";

function AboutUs() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Get in contact with the Mira Espresso team.</title>
        <meta name="description" content="Questions or suggestions, just E-Mail us." />
      </Helmet>

      {/* Landing Section */}
      <div className="landing">
        <FadeInAnimation delay={0.5}>
          <h1 className="mira_header">OUR STORY</h1>
        </FadeInAnimation>
      </div>

      {/* Section Header */}
      <div className="sectionHeaderContainer">
        <div className="blockSectionHeader">
          <FadeInAnimation>
            <h3>
              Mira Espresso started as a science project at the University of Kiel. We built a deep-learning model that adjusted espresso machine and grinder settings to improve every shot. The
              results were promising, but we saw even greater potential. To take it to the next level, we’re developing custom hardware—giving the system full control over the entire machine. Let's
              make great espresso chill.
            </h3>
          </FadeInAnimation>
        </div>
      </div>

      {/* Team Section */}
      <div className="thirds">
        <div className="third">
          <FadeInAnimation delay={0}>
            <div className="team-info" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <h3>Jesse Lindstädt</h3>
              {/* LinkedIn Icon */}
              <a href="https://www.linkedin.com/in/jesse-lindst%C3%A4dt-602517159/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  style={{ fill: "var(--color-text-grey)", transition: "fill 0.3s ease" }}
                  onMouseEnter={(e) => (e.currentTarget.style.fill = "var(--color-accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.fill = "var(--color-text-grey)")}
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
              {/* Mail Icon */}
              <a href="mailto:jesse@lindstaedt.com" style={{ color: "inherit", textDecoration: "none" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  style={{ fill: "var(--color-text-grey)", transition: "fill 0.3s ease" }}
                  onMouseEnter={(e) => (e.currentTarget.style.fill = "var(--color-accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.fill = "var(--color-text-grey)")}
                >
                  <path d="M0 4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm22 0H2v.511l10 7.5 10-7.5V4zm0 2.466l-10 7.5-10-7.5V20h20V6.466z" />
                </svg>
              </a>
            </div>
            <h4 style={{ color: "var(--color-text-grey)" }}>Founder & CEO</h4>
            <p>Computer Scientist and former pro sailor.</p>
            <p>
              "As a dedicated home barista, I recognized the challenges of perfecting every espresso shot. That sparked my research into harnessing Deep-Learning (AI) to automate espresso machine
              adjustments, paving the way for MIRA."
            </p>
          </FadeInAnimation>
        </div>
        <div className="third">
          <FadeInAnimation delay={0.3}>
            <h3>Prof. Dr. Sören Pirk</h3>
            <h4 style={{ color: "var(--color-text-grey)" }}>Scientific Advisor</h4>
            <p>Professor at Uni Kiel and head of the Computer Vision and Artificial Intelligence Lab.</p>
          </FadeInAnimation>
        </div>
      </div>
    </PageWrapper>
  );
}

export default AboutUs;
